import { IAppState } from '../../redux';
import { IAuctionServiceCost } from '../../redux/reducers';
import { selectCurrentServiceCost } from './selectCurrentServiceCost';

export function selectNextServiceCost(state: IAppState): IAuctionServiceCost | null {
  const {
    auction: { serviceCosts, currentBet },
  } = state;

  const currentServiceCost = selectCurrentServiceCost(state);

  if (!currentServiceCost) {
    return null;
  }

  const currentServiceCostIndex = serviceCosts.findIndex(({ serviceId }) => serviceId === currentServiceCost.serviceId);

  const nextServiceCost = serviceCosts
    .slice(currentServiceCostIndex + 1)
    .reverse()
    .find(serviceCost => currentServiceCost.cost + currentBet >= serviceCost.cost);

  return nextServiceCost || null;
}
